import Vue from 'vue'
import axios from 'axios'
import $ from 'jquery'
import VueMask from 'v-mask'

import App from './App.vue'

import router from './router'

import store from './store'
import {types} from './actions';

import {get_request, requests_methods, validation} from './mixins/requests'
import {ga_mixin} from './mixins/ga_mixin'

window.$ = $

axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    vue_instance.$store.commit('save_data',{key: 'loader', data: true})
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    vue_instance.$store.commit('save_data',{key: 'loader', data: false})
    return response;
}, function (error) {
    // Do something with response error
    vue_instance.$store.commit('save_data',{key: 'loader', data: false})
    return Promise.reject(error);
});



Vue.config.productionTip = false

Vue.use(VueMask);

var vue_instance = new Vue({
    router,
    store,
    mixins: [get_request, requests_methods, validation, ga_mixin],
    computed:{
        store(){
            return this.$store.state
        },
        reward_reservation_uid(){
            return this.store["reward_reservation.uid"]
        }
    },
    watch: {
        'store.new_jwt': {
            handler(){
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.new_jwt;
            }
        },
        'store.active_view': {
            handler(){

                if(this.$store.state.stages[this.$store.state.active_view] !== undefined){
                    this.$store.dispatch(types.FORM_DEFAULT_VALUES)
                }

                if(this.$store.state.stages[this.$store.state.active_view] !== undefined && this.$store.state.stages[this.$store.state.active_view].all.methods.get.active){
                    this.get_optional_data()
                }

                this.google_analitics_ids()
                this.google_analitics()
                this.google_analitics_event()

            }
        },
        reward_reservation_uid:{
            handler(val){
                console.log('test reward_reservation_uid',val)
                this.$store.commit('update_field',{key:'reward_reservation_uid',data: val})
            }
        },
        'store.expires_in':{
            handler(newVal,oldVal){
                if(oldVal === ''){
                    this.start_timer()
                }else if(newVal === 0){
                    store.commit('push_to_allowed_stages', 'time_passed')
                    this.$router.push({name:'time_passed'})
                }
            },
        }
    },
    methods:{
        start_timer(){
            window.timer = setInterval(()=>{
                var left_time = this.$store.state.expires_in - 1

                  this.$store.commit('save_data',{key:'expires_in',data: left_time})

                if(this.$store.state.expires_in < 1){
                    clearInterval(window.timer)
                }

            }, 1000);
        }
    },
    created() {
      this.$store.dispatch(types.GET_CONFIGS)
    },
    render: h => h(App)
}).$mount('#app')



